// LobbyContent.js

import React, { useEffect, useState } from "react";
import { socket } from '../../../helpers/global_helper';

import { withTranslation } from "react-i18next";
import dice1 from "../../../../src/assets/images/icons/dice_1.svg"
import dice2 from "../../../../src/assets/images/icons/dice_2.svg";
import dice3 from "../../../../src/assets/images/icons/dice_3.svg";
import dice4 from "../../../../src/assets/images/icons/dice_4.svg";
import dice5 from "../../../../src/assets/images/icons/dice_5.svg";
import dice6 from "../../../../src/assets/images/icons/dice_6.svg";

const DiceResult = (props) => {

    const roomColorNumber = {
        'SB': {
            "1": dice1,
            "2": dice2,
            "3": dice3,
            "4": dice4,
            "5": dice5,
            "6": dice6
        },
        'SB -NEW': {
            "1": dice1,
            "2": dice2,
            "3": dice3,
            "4": dice4,
            "5": dice5,
            "6": dice6
        }
    };
    const [result, setResult] = useState([]);

    useEffect(() => {
        socket.on("game_history", (result) => {
            if (result.room_id == props.room_id) {
                if (result.status != 'success') {
                    return;
                }
                let temp = [];
                for (let i = 0; i < result.results.length; i++) {
                    temp[i] = [...result.results[i]];
                    temp[i][3] = result.results[i].reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                    temp[i][4] = "Big";
                    temp[i][5] = "Odd";
                    temp[i][6] = "";
                    if (temp[i][0] == temp[i][1] && temp[i][1] == temp[i][2]) {
                        temp[i][6] = "3Number";
                    } else if (temp[i][3] >= 4 && temp[i][3] <= 10) {
                        temp[i][4] = 'Small';
                    }
                    if (temp[i][3] % 2 == 0) {
                        temp[i][5] = 'Even';
                    }
                }
                setResult([...temp]);
            }
        });
    }, [result]);

    useEffect(() => {
        socket.emit("game_history", { room_id: props.room_id });
    }, [props.room_id]);

    return (
        <>
            <div className="game_item_detail dragon-tiger">
                {/*--- sicbo history result--*/}
                <div className="sicbo_history_result">
                    {/* scibo row */}
                    {result.length > 0 && result.map((obj, index) => {
                       const isThreeNumber = obj.some(value => value === "3Number");
                        const pClassName = isThreeNumber ? "game_ding_dong_green" : "";
                        return (
                            <div key={index} className="sicbo_row">
                                <div className="sicbo_dice">
                                    <img src={roomColorNumber[props.game_code][obj[0]]} alt="" />
                                </div>
                                <div className="sicbo_dice">
                                    <img src={roomColorNumber[props.game_code][obj[1]]} alt="" />
                                </div>
                                <div className="sicbo_dice">
                                    <img src={roomColorNumber[props.game_code][obj[2]]} alt="" />
                                </div>
                                <p className="game_ding_dong_blue">{obj[3]}</p>
                                {
                                    obj[6] ? <p className={pClassName}>{props.t(obj[6].toLowerCase())}</p>
                                        :
                                        <>
                                            <p className="game_ding_dong_orange" >{props.t(obj[4].toLowerCase())}</p>
                                            <p >{props.t(obj[5].toLowerCase())}</p>
                                        </>
                                }
                            </div>
                        );
                    })}
                    {/* scibo row */}
                </div>
            </div>
        </>
    );
}

export default withTranslation()(DiceResult);
